import CountUp from 'packages/element-plus/count-up';
import Article from 'packages/element-plus/article';
import Crud from 'packages/element-plus/crud';
import Card from 'packages/element-plus/card';
import Chat from 'packages/element-plus/chat';
import Comment from 'packages/element-plus/comment';
import Form from 'packages/element-plus/form';
import Checkbox from 'packages/element-plus/checkbox';
import Date from 'packages/element-plus/date';
import Draggable from 'packages/element-plus/draggable';
import Flow from 'packages/element-plus/flow';
import Group from 'packages/element-plus/group';
import License from 'packages/element-plus/license';
import Time from 'packages/element-plus/time';
import Input from 'packages/element-plus/input';
import Radio from 'packages/element-plus/radio';
import Select from 'packages/element-plus/select';
import Cascader from 'packages/element-plus/cascader';
import InputColor from 'packages/element-plus/input-color';
import InputNumber from 'packages/element-plus/input-number';
import InputTree from 'packages/element-plus/input-tree';
import InputMap from 'packages/element-plus/input-map';
import InputIcon from 'packages/element-plus/input-icon';
import InputTag from 'packages/element-plus/input-tag';
import InputTable from 'packages/element-plus/input-table';
import InputCron from 'packages/element-plus/input-cron';
import Mention from 'packages/element-plus/mention';
import Verifys from 'packages/element-plus/verify';
import Switchs from 'packages/element-plus/switch';
import Rate from 'packages/element-plus/rate';
import Upload from 'packages/element-plus/upload';
import Sign from 'packages/element-plus/sign';
import Slider from 'packages/element-plus/slider';
import Tree from 'packages/element-plus/tree';
import Title from 'packages/element-plus/title';
import Search from 'packages/element-plus/search';
import Tabs from 'packages/element-plus/tabs';
import Dynamic from 'packages/element-plus/dynamic';
import Video from 'packages/element-plus/video';
import Login from 'packages/element-plus/login';
import Arrays from 'packages/element-plus/array';
import textEllipsis from 'packages/element-plus/text-ellipsis';
export default {
  Arrays,
  Article,
  Crud,
  Card,
  Chat,
  Comment,
  Form,
  Checkbox,
  Date,
  CountUp,
  Draggable,
  Flow,
  Group,
  License,
  Time,
  Input,
  Radio,
  Select,
  Cascader,
  InputColor,
  InputNumber,
  InputTree,
  InputIcon,
  InputMap,
  InputTag,
  InputTable,
  InputCron,
  Mention,
  Switchs,
  Rate,
  Upload,
  Slider,
  Tree,
  Title,
  Search,
  Tabs,
  Dynamic,
  Video,
  Verifys,
  textEllipsis,
  Sign,
  Login
};

